var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCalendarExpired = function SvgCalendarExpired(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#d3370d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.44 1.26H10.5V.14a.14.14 0 0 0-.14-.14h-.98a.14.14 0 0 0-.14.14v1.12H4.76V.14A.14.14 0 0 0 4.62 0h-.98a.14.14 0 0 0-.14.14v1.12H.56a.56.56 0 0 0-.56.56v11.62c0 .31.25.56.56.56h12.88c.31 0 .56-.25.56-.56V1.82a.56.56 0 0 0-.56-.56zm-.7 11.48H1.26V2.52H3.5v.84c0 .077.063.14.14.14h.98a.14.14 0 0 0 .14-.14v-.84h4.48v.84c0 .077.063.14.14.14h.98a.14.14 0 0 0 .14-.14v-.84h2.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.875 7h-5.75A.125.125 0 0 0 4 7.125v.75c0 .069.056.125.125.125h5.75A.125.125 0 0 0 10 7.875v-.75A.125.125 0 0 0 9.875 7z"
  }))));
};
export default SvgCalendarExpired;